import {useDispatch} from "react-redux";
import {setDialogScheduleAction} from "../../app/reducers/schedule-slice";
import {DeliveryGroup} from "../../types/schedule/delivery-group";
import {Schedule} from "../../types/schedule/schedule";
import {DeliveryGroupCard} from "./DeliveryGroupCard";

interface Props {
    deliveryGroup: DeliveryGroup;
    deliveryGroupIndex: number;
    schedule: Schedule;
}

export const DashboardDeliveryGroupCard: React.FC<Props> = (
    {
        deliveryGroup,
        deliveryGroupIndex,
        schedule,
    }
) => {
    const dispatch = useDispatch();

    const handleClickCard = () => {
        dispatch(
            setDialogScheduleAction({
                dialogSchedule: schedule,
                dialogDeliveryGroupIndex: deliveryGroupIndex,
            })
        );
    };

    return (
        <DeliveryGroupCard
            deliveryGroup={deliveryGroup}
            cardDeliveryGroupNumber={deliveryGroupIndex + 1}
            onClick={handleClickCard}
            schedule={schedule}
            deliveryGroupIndex={deliveryGroupIndex}
            isCurrentDeliveryGroup={
                schedule.currentDeliveryGroupIndex === deliveryGroupIndex
            }
        />
    );
};
